/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Password_Keep_HintInputs */

const vi_einvoice_credential_password_keep_hint = /** @type {(inputs: Einvoice_Credential_Password_Keep_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có mật khẩu được lưu. Để trống nếu bạn không đổi mật khẩu.`)
};

/**

* @param {Einvoice_Credential_Password_Keep_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_password_keep_hint = /** @type {((inputs?: Einvoice_Credential_Password_Keep_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Password_Keep_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_password_keep_hint(inputs)
});